var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.736929 5.01313C0.335912 5.39288 0.318665 6.02581 0.698407 6.42682C1.07815 6.82784 1.71108 6.84509 2.1121 6.46534L0.736929 5.01313ZM6.84144 1.9869C7.24246 1.60716 7.25971 0.97423 6.87996 0.573213C6.50022 0.172196 5.86729 0.154949 5.46628 0.534691L6.84144 1.9869ZM2.1121 6.46534L6.84144 1.9869L5.46628 0.534691L0.736929 5.01313L2.1121 6.46534Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98591 0.575632C1.56711 0.215602 0.935738 0.263247 0.575708 0.682051C0.215677 1.10085 0.263323 1.73222 0.682126 2.09225L1.98591 0.575632ZM5.62124 6.33823C6.04004 6.69826 6.67141 6.65062 7.03144 6.23181C7.39147 5.81301 7.34383 5.18164 6.92503 4.82161L5.62124 6.33823ZM0.682126 2.09225L5.62124 6.33823L6.92503 4.82161L1.98591 0.575632L0.682126 2.09225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.204b162c9d379f52ba0badab533d4488.svg";
export { ForwardRef as ReactComponent };